import { offlineAttendanceServiceUrl } from 'services/http';
export const offlineAttendanceEndpoints = {
	//offlineAttendance setup
    offlineAttendance : {
        endpoint : `${offlineAttendanceServiceUrl}/offline/machine`,
        getAll : `${offlineAttendanceServiceUrl}/offline/machines`,
    }
}